jQuery('.option select').change(function(e) {
    search_consultants();
}); 